import type { TColor } from '@Theme';
import type { FC } from 'react';
import React, { memo } from 'react';
import { Platform } from 'react-native';
import styled, { css } from 'styled-components/native';

import OwnableTheme from '../../assets/OwnableTheme';
import Icon from './Icons/Icon';
import { Touchable } from './Touchable';

type TButtonSize = 'large' | 'medium' | 'small' | 'xsmall' | 'xxsmall';
type RButtonSizes = Record<TButtonSize, number>;
const defaultButtonSize: TButtonSize = 'medium';
const buttonSizes: RButtonSizes = {
  large: 42,
  medium: 34,
  small: 30,
  xsmall: 26,
  xxsmall: 22,
};

const StyledCloseButton = styled.View<{
  size?: TButtonSize;
  bgColor?: TColor;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ bgColor }) => bgColor};
  width: ${({ size }) => buttonSizes[size ?? defaultButtonSize]}px;
  height: ${({ size }) => buttonSizes[size ?? defaultButtonSize]}px;
  border: 0;
  padding: 0;
  border-radius: 999px;
  ${Platform.OS === 'web' &&
  css`
    cursor: pointer;
  `};
`;

type IBuyButtonProps = {
  size?: TButtonSize;
  iconSize?: number;
  bgColor?: TColor;
  iconColor?: TColor;
  onPress?: () => void;
};

const CloseButton: FC<IBuyButtonProps> = memo(
  ({
    onPress,
    iconSize,
    size = defaultButtonSize,
    bgColor = 'transparent',
    iconColor = OwnableTheme.colors.persianIndigo,
  }) => {
    const onPressCallback = () => {
      if (typeof onPress === 'function') {
        onPress();
      }
    };

    return (
      // @ts-expect-error
      <Touchable onPress={onPressCallback}>
        <StyledCloseButton
          accessibilityLabel='Close'
          size={size}
          bgColor={bgColor}
        >
          <Icon
            icon='Close'
            cssColor={iconColor}
            cssSize={iconSize ?? buttonSizes[size]}
          />
        </StyledCloseButton>
      </Touchable>
    );
  }
);

export default CloseButton;
